import { render, staticRenderFns } from "./InsurerSecurityDashboard.vue?vue&type=template&id=140036e5&scoped=true"
import script from "./InsurerSecurityDashboard.vue?vue&type=script&lang=js"
export * from "./InsurerSecurityDashboard.vue?vue&type=script&lang=js"
import style0 from "./InsurerSecurityDashboard.vue?vue&type=style&index=0&id=140036e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140036e5",
  null
  
)

export default component.exports